import Vue from 'vue'
import Keycloak from 'keycloak-js'

const options = {
  url: window.env.VUE_APP_HCUB_URL,
  realm: window.env.VUE_APP_HCUB_REALM,
  clientId: window.env.VUE_APP_HCUB_CLIENT_ID
  // Should be added asap to comply with HCUB requirements
  // scope: window.env.VUE_APP_HCUB_SCOPES
}

const _keycloak = new Keycloak(options)

const Plugin = {
  install (Vue) {
    Vue.$keycloak = _keycloak
  }
}

Plugin.install = Vue => {
  Vue.$keycloak = _keycloak
  Object.defineProperties(Vue.prototype, {
    $keycloak: {
      get () {
        return _keycloak
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
